export default {
    id: 'MediaCenter',
    code: 'CN',
    text: {
      'Media Center': '媒体中心',
      'Upload Files': '上传文件',
      'Media Library': '媒体库',
      'Public Media Library': '公用媒体库',
      'Upload Successfully': '上传成功',
      'Proceed to delete image?': '确认删除图片吗？',
      'All Record': '所有纪录',
      'Uploading...': '上传中...',
    }
  }



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/locale.js